import { PAGES } from 'constants/pages';

export const HEADER_MOBILE_HEIGHT = 53;

export const HEADER_DESKTOP_HEIGHT = 80;

export const FOOTER_DESKTOP_HEIGHT = 50;

// Footer = 80px, Chat button = 48px
export const FOOTER_DESKTOP_HEIGHT_UPP = 72 + 44;

export const FOOTER_MOBILE_HEIGHT = 110;

// Footer 200px, Chat button = 56px
export const FOOTER_MOBILE_HEIGHT_UPP = 200 + 56;

// Footer = 127px, Chat button = 44px
export const FOOTER_TABLET_HEIGHT_UPP = 128 + 44;

export const maintenanceBannerWhitelist = [`${PAGES.MY}${PAGES.TESTS}`];
